import React from 'react';
import FileUploader from '../components/FileUploader';

const EncryptPage = () => {
  return (
    <div className="tool-page">
      <div className="page-header">
        <h1>🔒 Encrypt and Download ZIP</h1>
        <p className="subtitle">
          Secure client‑side encryption in your browser. Pick files or folders, set a strong
          password, and get a password‑protected ZIP archive.
        </p>
      </div>
      <section className="tool-card">
        <FileUploader />
      </section>
    </div>
  );
};

export default EncryptPage;
